import { registrationAPI } from 'helpers/firehydrantAPI';
import { createMutationHook, useApiQuery } from 'queries/common';

export const useAccountOverview = () => {
  const query = useApiQuery(['account', 'detail', 'overview'], () =>
    registrationAPI.get('organizations/api/account_overview'),
  );

  return {
    ...query,
    data: query?.data?.data || {},
  };
};

export const useBilling = () => {
  const query = useApiQuery(['billing', 'detail', 'current'], () =>
    registrationAPI.get('organizations/api/billing'),
  );

  return {
    ...query,
    data: query?.data?.data || {},
  };
};

export const useInvites = (options={}, params={}) => {
  const requestParams = { params: { state: 'active', ...params } };
  const query = useApiQuery(
    ['invitations', 'list', requestParams],
    () => registrationAPI.get('organizations/api/invitations', requestParams),
    options,
  );

  return {
    ...query,
    data: query?.data?.data?.data || [],
  };
};


const resendInvite = (id) =>
  registrationAPI.post(`organizations/api/invitations/${id}/resend`);

export const useResendInvite = createMutationHook(resendInvite);
